/**
 *
 * Pipe que marca caracteres em uma busca
 */

import { Pipe, PipeTransform } from '@angular/core';
import { removeAccents } from '../function/remove-accents';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  transform(value: string, searchTerm: string, color?: string): any {
    if (!searchTerm) {
      return value;
    }

    const valueNormalized = removeAccents(value);
    const searchTermNormalized = removeAccents(searchTerm);

    // Escapar caracteres especiais no termo de busca.
    const escapedSearchTerm = searchTermNormalized.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    // Criar uma expressão regular para encontrar a palavra-chave, ignorando acentos.
    const regex = new RegExp(escapedSearchTerm, 'gi');
    // Destacar as palavras encontradas mantendo o texto original.
    let result = value;
    // Executa a regex uma vez antes do loop.
    let match: RegExpExecArray | null = regex.exec(valueNormalized);

    while (match !== null) {
      // Pega o texto original usando a posição de correspondência no texto normalizado.
      const originalText = value.substring(match.index, match.index + match[0].length);
      // Substituir o texto original pela versão destacada.
      result = result.replace(originalText, `<mark class="mark">${originalText}</mark>`);
      // Executa a regex novamente para a próxima correspondência.
      match = regex.exec(valueNormalized);
    }

    return result;
  }
}

